import { Section, H2, DataField } from "../../components/common-components";
import { stripHtmlToPlainText } from "../../../../helpers/interventionHtml";

export const PharmacyFollowup = ({ formType, pharmacistFollowUp = {} }) => {
    const {
        additionalClinicalIssues = [],
        otherIssue = "",
    } = pharmacistFollowUp || {};

    // Canonical list to preserve labels and order (matches PharmacistFollowUp options)
    const clinicalIssuesOptions = [
        { value: "Drug - Drug Interaction", label: "Drug - Drug Interaction" },
        { value: "Drug - Disease Interaction", label: "Drug - Disease Interaction" },
        { value: "Adverse Drug Interaction", label: "Adverse Drug Interaction" },
        { value: "Drug Level Monitoring (narrow therapeutic index)", label: "Drug Level Monitoring (narrow therapeutic index)" },
        { value: "Therapy Change / Tolerance/ Effectiveness", label: "Therapy Change / Tolerance/ Effectiveness" },
        { value: "Medication Adherence", label: "Medication Adherence" },
        { value: "Multiple Drugs (Poly Pharmacy)", label: "Multiple Drugs (Poly Pharmacy)" },
        { value: "Complex Medication Regimen", label: "Complex Medication Regimen" },
        { value: "Recent or Frequent Falls", label: "Recent or Frequent Falls" },
        { value: "Frequent Hospital Admissions", label: "Frequent Hospital Admissions" },
        { value: "Chronic Disease Management", label: "Chronic Disease Management" },
        { value: "Under Treated Conditions", label: "Under Treated Conditions" },
        { value: "Untreated Conditions", label: "Untreated Conditions" },
        { value: "Other", label: "Other" }
    ];

    const checkedIssues = clinicalIssuesOptions.filter((opt) => additionalClinicalIssues.includes(opt.value));
    const hasAnyIssues = checkedIssues.length > 0 || !!otherIssue;

    return (
        <Section formType={formType}>
            <H2>Medication / Condition Review{!hasAnyIssues ? " - No additional issues at this time" : ""}</H2>
            {hasAnyIssues && (
                <div className="px-0">
                    <div className="flex-1 pr-2 py-2 space-y-2 border border-gray-100 text-teal-300 text-md bg-blue-50 px-2">
                        {checkedIssues.map((opt) => (
                            <DataField key={opt.value} label={opt.label} value={opt.label} />
                        ))}
                        {stripHtmlToPlainText(otherIssue).length > 0 ? (
                            <DataField
                                label="Other Issue"
                                value={stripHtmlToPlainText(otherIssue)}
                            />
                        ) : null}
                    </div>

                    <div className="mt-2 bg-white border border-gray-100 rounded w-full">
                        <div className="px-2 py-2 ">
                            <h3 className="font-semibold text-xs text-teal-300">
                                Pharmacist Suggestions
                            </h3>
                        </div>
                        <div className="p-4">{/* intentionally empty */}</div>
                    </div>
                </div>
            )}
        </Section>
    );
}